module.exports = __webpack_public_path__ + "static/media/conference-catering-2.728a899a.jpg";